import AlbumView from './AlbumView';
export default AlbumView;